/**
 * @author   Ikaros Kappler
 * @version  1.0.0
 * @date     2018-11-11
 **/
import { Color } from "./datastructures/Color";
/**
 * A mix of green shades.
 *
 * @requires Color
 */
export const WebColorsMalachite = [
    Color.makeRGB(0, 21, 6),
    Color.makeRGB(0, 30, 12),
    Color.makeRGB(0, 52, 28),
    Color.makeRGB(0, 81, 47),
    Color.makeRGB(21, 134, 88),
    Color.makeRGB(0, 46, 19),
    Color.makeRGB(0, 68, 40),
    Color.makeRGB(11, 81, 55),
    Color.makeRGB(0, 91, 46),
    Color.makeRGB(0, 111, 46),
    Color.makeRGB(33, 140, 106)
];
//# sourceMappingURL=WebColorsMalachite.js.map